import React from 'react';
import { Form } from 'rhombus-react';

import { CREATIVE_ASSET_TYPES } from 'utils/constants';
import { useSelector } from 'react-redux';

import './BuildMethodRadio.css';

const MULTIPLE_VERSIONS_TOOLTIP_MESSAGE = "Asset source cannot be edited once the creative has versions";

export default function BuildMethodRadio({ input, meta, ...props }){
	const inputProps = {
		...input,
		...props,
		meta,
	};

	const { disabled } = inputProps;
	const doVersionsExist = useSelector(state => state.creativeDetails?.numberOfVersions > 1);
	const tip = doVersionsExist ? MULTIPLE_VERSIONS_TOOLTIP_MESSAGE: "";

	const isRadioDisabled = disabled || doVersionsExist;

	return (
		<div className="build-method-radio">
			<span className="build-method-header">Build Method:</span>
			<div className="pre-built-radio" data-tip={tip}>
				<Form.Checkbox
					{...inputProps}
					label="Pre-built Assets"
					type="radio"
					disabled={isRadioDisabled}
					value={CREATIVE_ASSET_TYPES.PREBUILT}
					checked={input.value === CREATIVE_ASSET_TYPES.PREBUILT}
				/>
			</div>
			<div className="ad-studio-radio" data-tip={tip}>
				<Form.Checkbox
					{...inputProps}
					label="Ad Studio"
					type="radio"
					disabled={isRadioDisabled}
					value={CREATIVE_ASSET_TYPES.ADSTUDIO}
					checked={input.value === CREATIVE_ASSET_TYPES.ADSTUDIO}
				/>
			</div>
		</div>
	);
}

BuildMethodRadio.displayName = "BuildMethodRadio";

export const assetType = {
	name: "assetType",
	component: BuildMethodRadio,
};
